import CookieBannerDialog from './cookie-banner-dialog';

export { CookieBannerDialog };

export default CookieBannerDialog;
